import ScrollReveal from "scrollreveal";

export default function addScrollReveal() {
  function initReveal() {
    ScrollReveal().reveal(".js-reveal", {
      easing: "cubic-bezier(0.25, 0.1, 0.25, 1)",
      scale: "1",
      viewFactor: "0.05",
      distance: "50px",
      delay: "150",
      mobile: false,
      reset: false,
      duration: 800,
    });
  }

  const isPresent = document.getElementsByClassName("js-reveal");
  if (isPresent.length > 0) {
    initReveal();
  }
}
